import { FuseNavigation } from "@fuse/types";

export const navigation: FuseNavigation[] = [
    {
        id: "menu",
        title: "Opções Menu",
        type: "item",
        icon: "dashboard",
        url: "/menu",
    },
    // {
    //     id: 'dashboard',
    //     title: 'Dashboard',
    //     type: 'item',
    //     icon: 'dashboard',
    //     url: '/dashboard'
    // },
    {
        id: "esteira",
        title: "Esteira de Validação",
        type: "item",
        icon: "assignment",
        url: "/esteira",
    },
    // {
    //     id: 'integracaobancaria',
    //     title: 'Integração Bancária',
    //     type: 'item',
    //     icon: 'assignment',
    //     url: '/integracaobancaria'
    // },
    {
        id: "gestorfinanceiro",
        title: "Gestor Financeiro",
        type: "collapsable",
        icon: "chat",
        children: [
            {
                id: "integracaobancaria",
                title: "Integração Bancária",
                type: "item",
                url: "/integracaobancaria",
            },

            {
                id: "relatorioCobranca",
                title: "Relatório de Cobrança",
                type: "item",
                url: "/relatorioCobranca",
            },
            {
                id: "critica-registro-boleto",
                title: "Relatório de Cobrança com erro",
                type: "item",
                url: "/critica-registro-boleto",
            },
        ],
    },

    // {
    //     id: "notificacoes",
    //     title: "Central de Notificações",
    //     type: "collapsable",
    //     icon: "chat",
    //     children: [
    //         {
    //             id: "regrasNotificacoes",
    //             title: "Cadastrar",
    //             type: "item",
    //             url: "/regrasNotificacoes",
    //         },
    //     ],
    // },

    {
        id: "restrita",
        title: "Área Restrita",
        type: "collapsable",
        icon: "description",
        children: [
            // {
            //     id: "paginainicial",
            //     title: "Página Inicial",
            //     type: "item",
            //     url: "/paginaInicial",
            // },

            // {
            //     id: "dadosparticipante",
            //     title: "Dados do Participante",
            //     type: "item",
            //     url: "/dadosParticipante",
            // },
            {
                id: "mensagemModulo",
                title: "Cadastrar Mensagem para Modulo",
                type: "item",
                url: "/mensagemModulo",
            },
                        {
                id: "mensagemExcecao",
                title: "Cadastrar Mensagem de Exceção",
                type: "item",
                url: "/mensagemExcecao",
            },
            // {
            //     id: "edicaodependentes",
            //     title: "Edição de Dependentes",
            //     type: "item",
            //     url: "/edicaoDependentes",
            // },

            // {
            //     id: "inclusaodependentes",
            //     title: "Inclusão de Dependentes",
            //     type: "item",
            //     url: "/inclusaoDependentes",
            // },

            // {
            //     id: "planoinstituido",
            //     title: "Plano Instituído",
            //     type: "item",
            //     url: "/planoInstituido",
            // },

            // {
            //     id: "recadastramento",
            //     title: "Recadastramento",
            //     type: "item",
            //     url: "/recadastramento",
            // },

            // {
            //     id: "contribuicao",
            //     title: "Contribuição",
            //     type: "item",
            //     url: "/contribuicao",
            // },

            // {
            //     id: "cobranca",
            //     title: "Cobrança",
            //     type: "item",
            //     url: "/cobranca",
            // },

            // {
            //     id: "requerimentobeneficio",
            //     title: "Requerimento de Benefício",
            //     type: "item",
            //     url: "/requerimentoBeneficio",
            // },

            // {
            //     id: "alteracaobeneficio",
            //     title: "Alteração de Benefício",
            //     type: "item",
            //     url: "/alteracaoBeneficio",
            // },

            // {
            //     id: "simuladorbeneficio",
            //     title: "Simulador de Benefício",
            //     type: "item",
            //     url: "/simuladorBeneficio",
            // },

            // {
            //     id: "emprestimos",
            //     title: "Empréstimos",
            //     type: "item",
            //     url: "/emprestimo",
            // },

            // {
            //     id: "dossieparticipante",
            //     title: "Dôssie do Participante",
            //     type: "item",
            //     url: "/dossieParticipante",
            // },

            // {
            //     id: "dashboard",
            //     title: "Dashboard",
            //     type: "item",
            //     url: "/configDashboard",
            // },

            // {
            //     id: "atas",
            //     title: "Atas",
            //     type: "item",
            //     url: "/configAtas",
            // },

            // {
            //     id: "fornecedores",
            //     title: "Fornecedores",
            //     type: "item",
            //     url: "/configFornecedores",
            // },
            {
                id: "Mensagem",
                title: "Mensagem Funcionalidade",
                type: "item",
                url: "/configMensagemFunc",
            },
            // {
            //     id: "funcionalidade",
            //     title: "Funcionalidade",
            //     type: "item",
            //     url: "/configFuncionalidade",
            // },

            // {
            //     id: "funcionalidades",
            //     title: "Funcionalidades",
            //     type: "item",
            //     url: "/configFuncionalidades",
            // },

            // {
            //     id: "notificaoparticipante",
            //     title: "Envio de Notificação",
            //     type: "item",
            //     url: "/notificacaoParticipante",
            // },

            // {
            //     id: "simulacoes",
            //     title: "Simulações",
            //     type: "item",
            //     url: "/simulacoes",
            // },
        ],
    },

    {
        id: "areaInterativa",
        title: "Área Interativa",
        type: "collapsable",
        icon: "description",
        children: [
            {
                id: "uploaddocumentos",
                title: "Upload Documentos",
                type: "item",
                url: "/upload",
            },

            {
                id: "administrardocumentos",
                title: "Administrar Documentos",
                type: "item",
                url: "/documentos",
            },

            {
                id: "consultardocumentos",
                title: "Consultar Documentos",
                type: "item",
                url: "/consultarDocumentos",
            },

            // {
            //     id: "consultarconvites",
            //     title: "Consultar Convites",
            //     type: "item",
            //     url: "/consultarConvites",
            // },

            // {
            //     id: "perguntasrespostas",
            //     title: "Perguntas Respostas",
            //     type: "item",
            //     url: "/pergunta-resposta",
            // },
        ],
    },
    // {
    //     id: "enviaremail",
    //     title: "Envio de E-mail",
    //     type: "collapsable",
    //     icon: "description",
    //     children: [
    //         {
    //             id: "enviaremail",
    //             title: "Institutos Legais",
    //             type: "item",
    //             url: "/enviar-email",
    //         },
    //     ],
    // },

    // {
    //     id: "mensageria",
    //     title: "Mensageria",
    //     type: "collapsable",
    //     icon: "description",
    //     children: [
    //         {
    //             id: "mensageria-integracaobancaria",
    //             title: "Disparo de e-mails",
    //             type: "item",
    //             url: "/mensageria-integracaobancaria",
    //         },
    //         {
    //             id: "mensageria-relatoriocobrancacomerro",
    //             title: "Relatório de e-mail com erro",
    //             type: "item",
    //             url: "/mensageria-relatoriocobrancacomerro",
    //         },
    //     ],
    // },
];
